"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Countries;
(function (Countries) {
    Countries["se"] = "swedish";
    Countries["no"] = "norwegian";
    Countries["fi"] = "finnish";
})(Countries || (Countries = {}));
class PersonnummerError extends Error {
    constructor(country) {
        super(`Invalid ${Countries[country]} personal identity number`);
    }
}
exports.default = PersonnummerError;
//# sourceMappingURL=errors.js.map